module.exports = __webpack_public_path__ + "7a0951b4cbddb5d11b6fb1511deb6f67.csv";


/*****************
 ** WEBPACK FOOTER
 ** ./client/components/importer/sample/coupons.csv
 ** module id = 1298
 ** module chunks = 0
 **/